if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if(this.form.querySelector('[name=id]')) {
        this.form.querySelector('[name=id]').disabled = false;
      }
      
      this.cartNotification = document.querySelector('cart-notification');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');

      if(this.cartNotification && this.cartDrawer) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      this.recipientForm = (this.querySelector('recipient-form')) ? true : false;
      if(this.recipientForm){
        this.sectionId = this.form.getAttribute('id').replace('product-form-','');
        this.checkboxInputRF = this.querySelector(`#Recipient-checkbox-${ this.sectionId }`);
        this.checkboxInputRF.disabled = false;
        this.checkboxInputRF.checked = true;
        this.hiddenControlFieldRF = this.querySelector(`#Recipient-control-${ this.sectionId }`);
        this.hiddenControlFieldRF.disabled = true;
        this.emailInputRF = this.querySelector(`#Recipient-email-${ this.sectionId }`);
        this.nameInputRF = this.querySelector(`#Recipient-name-${ this.sectionId }`);
        this.messageInputRF = this.querySelector(`#Recipient-message-${ this.sectionId }`);
        this.sendonInputRF = this.querySelector(`#Recipient-send-on-${ this.sectionId }`);
        this.offsetPropertyRF = this.querySelector(`#Recipient-timezone-offset-${ this.sectionId }`);
        if (this.offsetPropertyRF) this.offsetPropertyRF.value = new Date().getTimezoneOffset();

        this.addEventListener('change', this.onChangeRF.bind(this));
        this.onChangeRF();
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      if(this.cartNotification) {
        this.cartNotification.setActiveElement(document.activeElement);
      }

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if(this.cartNotification && this.cartDrawer) {
        formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id) + ',cart-drawer');
      }
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            if(this.recipientForm){
              if (typeof response.description === 'object') {
                return Object.entries(response.description).forEach(([key, value]) => {
                  const errorMessageId = `RecipientForm-${ key }-error-${ this.sectionId }`
                  const fieldSelector = `#Recipient-${ key }-${ this.sectionId }`;
                  const message = `${value.join(', ')}`;
                  const errorMessageElement = this.querySelector(`#${errorMessageId}`);
                  const errorTextElement = errorMessageElement?.querySelector('.error-message')

                  if (!errorTextElement) return;

                  errorTextElement.innerText = `${message}.`;
                  errorMessageElement.classList.remove('hidden');
        
                  const inputElement = this[`${key}Input`];
                  if (!inputElement) return;
       
                  inputElement.setAttribute('aria-invalid', true);
                  inputElement.setAttribute('aria-describedby', errorMessageId);
                });
              }
            }

            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            if(this.cartNotification) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cartNotification.renderContents(response) });
              }, { once: true });
            }
            quickAddModal.hide(true);
          } else {
            if(this.cartNotification) {
              this.cartNotification.renderContents(response);
            }
            //this.handleAddToCartDataLayer(response);
            if(this.cartDrawer) {
              this.cartDrawer.renderContents(response);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cartDrawer && this.cartDrawer.classList.contains('is-empty')) this.cartDrawer.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    onChangeRF() {
      if (this.checkboxInputRF.checked) {
        this.enableInputFieldsRF();
      } else {
        this.clearInputFieldsRF();
        this.disableInputFieldsRF();
      }
    }

    inputFieldsRF() {
      return [
        this.emailInputRF,
        this.nameInputRF,
        this.messageInputRF,
        this.sendonInputRF
      ];
    }

    disableableFieldsRF() {
      return [...this.inputFieldsRF(), this.offsetPropertyRF];
    }

    clearInputFieldsRF() {
      this.inputFieldsRF().forEach((field) => field.value = '');
    }

    enableInputFieldsRF() {
      this.disableableFieldsRF().forEach((field) => field.disabled = false);
    }

    disableInputFieldsRF() {
      this.disableableFieldsRF().forEach((field) => field.disabled = true);
    }

    handleAddToCartDataLayer(response) {
      let addedItems = [];
      for (const product of response.items) { 
        if(product.quantity > 0) {
          let added = {
            id: product.sku.substring(0,product.sku.indexOf(' -qb')),
            name: product.product_title,
            brand: product.vendor,
            variant: product.variant_title,
            price: product.final_price * 0.01,
            quantity: product.quantity,
            dimension2: 'detail'
          };
          addedItems.push(added);
        }

      }

      /* window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null }); 
      window.dataLayer.push({
        event: "addToCart",
        ecommerce: {
          currencyCode: 'USD',
          add: {
            products: addedItems
          }
          
        }
      }); */
    }
  });
}
